import { render, staticRenderFns } from "./ReportTopProduct.vue?vue&type=template&id=0ade8959&"
import script from "./ReportTopProduct.vue?vue&type=script&lang=js&"
export * from "./ReportTopProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports